import React from 'react';
import { Button } from 'primereact/button';
import '../../../assets/css/teacherMaster.css';
import { useNavigate } from 'react-router-dom';
import { apiBase } from '../../../utils/config';
import { InputSwitch } from 'primereact/inputswitch';
import { Checkbox } from 'primereact/checkbox';

const StudentCard = ({ student, handleDelete, toggleActiveStatus, handleResetDialog, AccessList, selectedStudents, onSelectStudent, pageAccess }) => {
    const navigate = useNavigate();
    const initials = (student?.Name || '')
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(n => n[0]?.toUpperCase())
        .join('') || '?';
    const isActive = student?.Status === 'Active';

    return (
        <div className="teacher-card et-scard">
            {pageAccess?.DeleteAccess &&
                <Checkbox
                    className="et-scard-check"
                    inputId={`select-${student?._id}`}
                    checked={Array.isArray(selectedStudents) && selectedStudents.some(s => s?._id === student?._id)}
                    onClick={() => onSelectStudent(student)}
                />}

            <div className="et-scard-av">
                <span>{initials}</span>
                {student?.ProfilePhotoUrl
                    ? <img src={`${apiBase}/UserProfilePic/${student?.ProfilePhotoUrl}`} alt="" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                    : null}
            </div>

            <h4 className="e-student-name p-text-capitalize">{student?.Name}</h4>
            <div className="et-scard-meta">
                {student?.StudentId}{student?.ClassFullName ? ` · ${student?.ClassFullName}` : ''}
            </div>
            <span className={`et-spill et-scard-status ${isActive ? 'et-spill--green' : 'et-spill--gray'}`}>
                {isActive ? 'Active' : 'Inactive'}
            </span>

            <div className="et-scard-actions">
                {pageAccess?.ViewAccess &&
                    <Button icon="icon-view tailer-icon" className="e-sction-btn" onClick={() => navigate('/viewEdit-student-master', { state: { userId: student?._id, isEdit: false } })} />}
                {pageAccess?.EditAccess &&
                    <Button icon="pi pi-pencil" className="e-sction-btn" onClick={() => navigate('/viewEdit-student-master', { state: { userId: student?._id, isEdit: true } })} />}
                {pageAccess?.DeleteAccess &&
                    <Button icon="pi pi-trash" className="e-sction-btn" onClick={(e) => handleDelete(student?._id)} />}
                {pageAccess?.EditAccess && (
                    <>
                        <InputSwitch
                            checked={isActive}
                            onChange={(e) => toggleActiveStatus(student._id, e.value)}
                            className="p-mx-1"
                        />
                        {!student?.IsNoLogin &&
                            <Button icon="pi pi-ban" className="e-sction-btn" onClick={(e) => handleResetDialog(student?._id, 'NoLogin')} />}
                        {student?.IsNoLogin && AccessList?.IsStudent &&
                            <Button icon="pi pi-key" className="e-sction-btn" onClick={(e) => handleResetDialog(student?._id, 'Password')} />}
                    </>)}
            </div>
        </div>
    );
}

export default StudentCard;
